/** 兼容子路径部署（如 /threejsMap） */
export function assetUrl(path: string): string {
  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${base}${normalized}`;
}
